import React, {useEffect, useState} from "react";

interface DelayedFadeInProps {
  delay: number;
  className?: string;
  children: React.ReactNode;
}

const DelayedFadeIn: React.FC<DelayedFadeInProps> = React.memo(({ children, delay = 2000, className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <div className={`transform w-full max-w-full transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'} ${className}`}>
      {children}
    </div>
  );
});

export  default DelayedFadeIn;